import * as m from "mithril";
import AppContext from "../../context/AppContext";
import { NavBar } from '../../components/NavBar';
import LoadingIndicator from "../../components/LoadingIndicator";
import dayjs = require("dayjs");
import { BookingDTO, BookingSummaryDTO } from "../../apiclient/ApiDtos";
import { getIntlStringValue } from "../../helpers/StringHelpers";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import './BookingListPage.scss';

interface Attrs {
    appContext: AppContext,
    status: "fetching" | "showing",
    bookings: BookingSummaryDTO[] | null,
    onBackPressed: () => void,
    onViewDetails: (booking: BookingSummaryDTO) => void
}

function BookingListPage(): m.Component<Attrs> {
    return {
        view(vnode) {
            console.log("booking list status " + vnode.attrs.status)

            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let currentLang = messageProvider.getCurrentLang();

            let actionItems = [
                {
                    label: "EN",
                    onclick: () => {
                        vnode.attrs.appContext.setLangauge("en");
                    }
                },
                {
                    label: messageProvider.get("lang.my"),
                    onclick: () => {
                        vnode.attrs.appContext.setLangauge("my");
                    }
                }
            ];

            return m('div', { class: "app-layout" },
                [
                    m(NavBar, {
                        title: messageProvider.get("nav_menu.my_bookings"),
                        canBackPress: true,
                        onBackPressed: () => vnode.attrs.onBackPressed(),
                        actionItems: actionItems,
                    }),

                    m("div.app-area-main p-2",
                        (vnode.attrs.status == 'showing') ?
                            [
                                (vnode.attrs.bookings?.length == 0)?
                                m("div", { class: "pt-3" }, [
                                    m("h5", { class: "text-center font-weight-bold" }, messageProvider.get("my_bookings.no_booking_message_title")),
                                    m("div", { class: "text-center text-muted font-italic" }, messageProvider.get("my_bookings.no_booking_message_description"))
                                ]): null,
                                vnode.attrs.bookings?.map(booking =>
                                    m(BookingCard, {
                                        booking:booking,
                                        appContext: vnode.attrs.appContext,
                                        onBookingSelected:(booking) => {
                                            vnode.attrs.onViewDetails(booking);
                                        }
                                    })
                                )
                            ] :
                            m(LoadingIndicator),
                    ),


                ]);
        }
    }
};


function BookingCard(): m.Component<{
    appContext: AppContext,
    booking:BookingSummaryDTO, 
    onBookingSelected:(booking:BookingSummaryDTO) => void
}> {
    return {
        view(vnode) {
            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let currentLang = messageProvider.getCurrentLang();
            let booking = vnode.attrs.booking;

            return m("div.card mb-2 _bg-white shadow-sm _border-secondary", {
                class: booking.status.toLowerCase() != 'confirmed'? "border-warning": "",
                onclick: function (event) {
                    vnode.attrs.onBookingSelected(vnode.attrs.booking);
                }
            },
                m("div.card-body _bg-white",
                    booking.status.toLowerCase() != 'confirmed'?
                    m("div.d-flex align-items-center text-righttext-end mb-2",{
                        style: "margin-top: -15px !important; color: rgb(189, 154, 17) !important;"
                    },
                        m("span.processing-loader"),
                        m("span.ml-2 pt-1 py-0 small rounded", messageProvider.get("my_bookings.processint_status", currentLang)) //လုပ်ဆောင်နေဆဲ
                    )
                    : null,
                    //m("div.w-100 text-muted text-end _text-primary", m("small", dayjs(booking.createdAt).format("MMM DD, hh:mm A"))),
                    
                    m("div.text-body-sm-",
                        m("span.text-primary -font-weight-bold", 
                            getIntlStringValue(booking.trip.departure.location.name, currentLang) + " - " + getIntlStringValue(booking.trip.arrival.location.name, currentLang)),
                        m(CustomSvgIcon, {
                            iconType: 'circle_dot',
                            themeCssClass: "svg-medium svg-muted"
                        }),
                        m("span.text-primary --font-weight-bold", dayjs(booking.trip.departure.scheduledAt).format("MMM DD, hh:mm A"))
                    ),

                    m("div.mt-2 text-body-sm",   
                        m("span", getIntlStringValue(booking.trip.operator.name, currentLang)),
                        m("span", " | "),
                        m("span", getIntlStringValue(booking.trip.busType, currentLang))                                               
                    ),

                    m("div.mt-2 text-body-sm",    
                        m("span", booking.seatOrder.seatSelections.length + " " + (booking.seatOrder.seatSelections.length > 1 ? messageProvider.get("seats") : messageProvider.get("seat"))),                                                                    
                        m(CustomSvgIcon, {
                            iconType: 'circle_dot',
                            themeCssClass: "svg-small svg-muted"
                        }),
                        m("span", booking.traveller.name)
                        
                        /*
                        m("span", messageProvider.get("seat_selection.seat_numbers") + ": "),
                        m("span.text-secondary", 
                             booking.seatNumbers.join(", ") 
                        )  */                      
                    ),

                    m("div.text-muted mt-1",
                        m("small.text-body-sm- mr-1", "Ref #"),   
                        m("small.text-body-sm-", booking.referenceNumber),   
                        m("small.text-body-sm-", " | " + messageProvider.get("booking.purchased_date") + ": " + dayjs(booking.createdAt).format("YYYY/MM/DD hh:mm A"))                  
                    ),
                )
            )
        }
    }
}


export default BookingListPage;